<script>
	import thumb___GjErcbQzU from '$lib/Components/Youtube/images/__GjErcbQzU.jpg?w=610';
	import thumb_vF3wwRYpJpQ from '$lib/Components/Youtube/images/vF3wwRYpJpQ.jpg?w=610';

	import Button from '$lib/Components/Layout/Button/Button.svelte';
	import Image from '$lib/Components/Layout/Image/Image.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import Youtube from '$lib/Components/Youtube/Youtube.svelte';
	import Lead from '$lib/PageSections/Forms/Lead/Lead.svelte';
	import GetAFreeEstimate from '$lib/PageSections/GetAFreeEstimate/GetAFreeEstimate.svelte';
	import Reviews from '$lib/PageSections/Reviews/Reviews.svelte';

	import titleImage from './images/IW-LP-Bigfoot-001.jpg';
	import creatureComforts from './images/IW-LP-Bigfoot-002.png';
	import bigFootQuote from './images/IW-LP-Bigfoot-003.png';
	import bigFootInsert from './images/IW-LP-Bigfoot-004.png';
	import bigFootCoins from './images/IW-LP-Bigfoot-007.png';
</script>

<Section
	backgroundImage={titleImage}
	backgroundColor="blue"
	innerClass={[].join(' ')}
>
	<div
		class="
    grid grid-cols-1 place-items-center gap-x-16
    md:grid-cols-2
  "
	>
		<div></div>
		<div class="flex max-w-2xl flex-col gap-4">
			<div class="grid w-full py-12">
				<h1
					class="
       max-w-[19ch]
       md:justify-self-end md:px-0 md:text-left
     "
				>
					Big Problems <br />Require Smart <br />Solutions
				</h1>
			</div>
		</div>
	</div>
</Section>
<Section backgroundColor="white">
	<div
		class="
    grid grid-cols-1 place-items-center gap-16
    md:grid-cols-2
  "
	>
		<div class="grid justify-items-center gap-4">
			<Image
				class="w-full"
				src={creatureComforts}
				alt="Bigfoot peacefully resting within his cozy home unbothered by the winter storm outside"
			/>
		</div>
		<div>
			<h2 class="text-[clamp(2rem,5vw,2.3rem)] text-indow-blue">
				Creature Comforts
			</h2>

			<p>
				When you’re dealing with frigid temperatures that fill your home with
				chills, high energy bills that lighten your wallet, or loud noises that
				leave you sleep-deprived, it can make your home feel more like a cave
				than a cozy oasis. Indow inserts are the premium solution to eliminating
				all of the most common issues with windows, without preventing your
				windows from doing what they do best - let in light!
			</p>
			<p>
				When Bigfoot needed a way to maintain his comfort and quiet in the
				modern world, he chose Indow because he knew he’d see results. Indow
				customers experience an average energy savings of 20% and up to 70%
				noise reduction with acoustic inserts. Bigfoot also knew he could trust
				Indow to deliver a quality, carefree solution backed by <a
					href="/warranties/snug-fit-guarantee">Indow’s Snug Fit Guarantee</a
				>,
				<a href="/warranties/residential-lifetime-warranty">Lifetime Warranty</a
				>, and over
				<a href="https://reviews.io/company-reviews/store/indow1" rel="external"
					>a thousand 5-star reviews
				</a>.
			</p>
			<p>
				What does Bigfoot think about his inserts now that he’s installed them?
			</p>
		</div>
	</div>
</Section>
<Section backgroundColor="grey" innerClass="gap-y-4">
	<Image
		src={bigFootQuote}
		class="max-w-72"
		alt="Bigfoot proudly showcasing new Indow Window Insert that he will install inside his cabin"
	/>
	<p
		class="max-w-[25ch] text-[clamp(2rem,5vw,3rem)] leading-tight font-thin"
		style="text-wrap:balance;"
	>
		"Installation easy. Noisy neighbors no more. Bigfoot cabin cozy all year
		long."
	</p>

	<p class="font-bold italic">&mdash; Bigfoot</p>
</Section>
<Section backgroundColor="grey-light" class="pb-0!">
	<div
		class="
    grid grid-cols-1 gap-x-16
    md:grid-cols-2
  "
	>
		<div>
			<h2 class="text-[clamp(2rem,5vw,2.3rem)] text-indow-blue">
				No More Window Worries
			</h2>
			<p>
				No matter what window issues you face - cold or hot weather, noise
				disturbances, high energy bills, light-blocking, and even combating
				climate change - Indow has an insert that will upgrade windows of all
				sizes and shapes! Eliminate your window worries with a Free Estimate
				today!
			</p>
			<p>
				Fill out this form and one of our Comfort Experts will be in touch to
				prepare a specialized estimate for your space.
			</p>
			<Image
				src={bigFootInsert}
				class="
      hidden max-w-64
      md:block
    "
				alt="Bigfoot holding an Indow window insert horizontally"
			/>
		</div>
		<div
			class="
     max-w-lg
     md:pb-16
   "
		>
			<Lead buttonText="Contact Me" textString={false} />
		</div>
	</div>
	<Image
		src={bigFootInsert}
		class="
    mb-0 max-w-64 pt-8
    md:hidden
  "
	/>
</Section>
<Section backgroundColor="blue">
	<div
		class="
    grid-cols-1 gap-x-16
    max-md:contents
    md:grid md:grid-flow-row md:grid-cols-2 md:grid-rows-[auto_1fr]
  "
	>
		<div class="contents">
			<h2
				class="
      col-start-2 text-2xl font-bold
      md:col-start-1 md:row-start-1 md:max-w-[15ch]
    "
				style="text-wrap: balance;"
			>
				See Bigfoot Combat Cold Drafts
			</h2>

			<Youtube
				posterImageSrc={thumb___GjErcbQzU}
				src="https://www.youtube.com/embed/__GjErcbQzU"
				class="
      max-md:mb-8!
      md:col-start-1
    "
			/>
		</div>
		<div class="contents">
			<h2
				class="
      col-start-2 text-2xl font-bold
      md:row-start-1
    "
				style="text-wrap: balance;"
			>
				See Bigfoot Shut Out Noisy Neighbors
			</h2>
			<Youtube
				posterImageSrc={thumb_vF3wwRYpJpQ}
				src="https://www.youtube.com/embed/vF3wwRYpJpQ"
				class="md:col-start-2"
			/>
		</div>
	</div>
</Section>
<Section backgroundColor="grey-light">
	<div
		class="
    grid grid-cols-1 gap-8 gap-x-16
    md:grid-cols-2
  "
	>
		<div>
			<h2
				class="
      text-[clamp(2rem,5vw,2.3rem)] text-indow-blue
      md:px-0
    "
			>
				Huge Savings On Inserts
			</h2>
			<p>
				You can save 30% on the cost of energy-saving Indow window inserts with
				tax credits from the Inflation Reduction Act. With these tax credits,
				you can lower your tax bill by up to $1,200 by purchasing approved
				energy efficient window inserts - that's over $100 in savings on a
				standard size Indow window insert!
			</p>
			<p>
				The best part? Indow's insulating window inserts qualify for this tax
				savings of up to $1,200/year on energy efficient home improvements.
			</p>

			<Button href="/window-insert-tax-savings">LEARN MORE</Button>
		</div>
		<div
			class="
     row-start-1 self-center
     md:row-auto
   "
		>
			<Image
				src={bigFootCoins}
				class="
      max-w-96
      md:w-full
    "
				alt="Bigfoot leaning against a stack of coins saved by upgrading to energy-efficient Indow Window Inserts"
			/>
		</div>
	</div>
</Section>
<Reviews />
<GetAFreeEstimate />
